import { GLOBAL_FETCH_SIGNAL, fetchUrl } from "./settings";

import { ActionType } from '../action-types';
import fetch from "fetch-retry";
export const GET_MEASUREMENTS = 'GET_MEASUREMENTS';

export const getMeasurements = formData => (dispatch, getState) => {
    let token = localStorage.getItem('w4-token');
    dispatch({ type: ActionType.MEASUREMENTS_LOADING, measurementsLoading: true });
    return fetch(`${fetchUrl}/measurements`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        signal: GLOBAL_FETCH_SIGNAL,
        body: JSON.stringify(formData),
        retries: 5,
        retryDelay: 1000,
        timeout: 200000,
        retryOn: function (attempt, error, response) {
            // retry on any network error, or 4xx or 5xx status codes
            if (error !== null || response.status >= 400) {
                return true;
            }
        }
    })
        .then(resp => resp.json())
        .then(data => {
            return dispatch({ type: ActionType.GET_MEASUREMENTS, measurements: data });
        })
}
